import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Page, PageEmptyState, PageErrorState, Typography } from 'seagull';
import { CreateProposalButton } from '~/components/CreateProposalButton/CreateProposalButton';
import SeeWhatItsLike from '~/components/SeeWhatItsLike/SeeWhatItsLike';
import { useLocaleKeys } from '~/i18n';
import EmptyStateIllustartion from './InvoiceDashboardEmptyStateIllustration.svg';
import img1 from './SeeWhatItsLikeImages/1.png';
import img2 from './SeeWhatItsLikeImages/2.png';
export const NoInvoices = (param)=>{
    let { title, isVendor } = param;
    const { t: emptyStatesTexts } = useLocaleKeys('invoice.emptyStates');
    const { t: emptyStateTexts } = useLocaleKeys('components.invoicesEmptyStates');
    return /*#__PURE__*/ _jsx(Page, {
        header: title,
        variant: "containedHeight",
        children: /*#__PURE__*/ _jsx(PageEmptyState, {
            maxHeight: true,
            testId: "invoices-empty",
            illustration: /*#__PURE__*/ _jsx(EmptyStateIllustartion, {}),
            title: emptyStatesTexts.automaticTitle(),
            message: emptyStatesTexts.automaticMessage(),
            actions: isVendor && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SeeWhatItsLike, {
                        steps: [
                            {
                                title: emptyStateTexts.issueAndGetPaid(),
                                subtitle: emptyStateTexts.invoiceAccessibleSubtitle(),
                                image: {
                                    src: img1,
                                    width: 1246,
                                    height: 737
                                }
                            },
                            {
                                title: emptyStatesTexts.gettingPaidSeamless(),
                                subtitle: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            skin: "invertedStandard",
                                            children: emptyStateTexts.gettingPaidSeamlessSubtitle()
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            skin: "invertedStandard",
                                            children: emptyStateTexts.gettingPaidSeamlessTip()
                                        })
                                    ]
                                }),
                                image: {
                                    src: img2,
                                    width: 1246,
                                    height: 737
                                }
                            }
                        ],
                        testId: "invoices-dashboard"
                    }, "see-what-its-like"),
                    /*#__PURE__*/ _jsx(CreateProposalButton, {}, "create-proposal-button")
                ]
            })
        })
    });
};
export const NoFilteredInvoices = (param)=>{
    let { resetFilters } = param;
    const { t: emptyStatesTexts } = useLocaleKeys('invoice.emptyStates');
    return /*#__PURE__*/ _jsx(PageEmptyState, {
        testId: "invoices-no-match",
        illustration: /*#__PURE__*/ _jsx(EmptyStateIllustartion, {}),
        title: emptyStatesTexts.noMatchTitle(),
        message: emptyStatesTexts.noMatchMessage(),
        actions: /*#__PURE__*/ _jsx(Button, {
            bi: {
                name: 'reset_invoice_filters'
            },
            onClick: resetFilters,
            children: emptyStatesTexts.removeAllFilters()
        })
    });
};
export const ErrorPage = (param)=>{
    let { retry, title } = param;
    return /*#__PURE__*/ _jsx(PageErrorState, {
        testId: "error-state-page",
        title: title,
        onRefresh: retry
    });
};
